<template>
  <div
    class="scroll-container"
    :class="{ 'is-native': useNativeScroll }"
    ref="scrollContainer"
    @wheel="handleScroll"
  >
    <div
      class="scroll-wrapper"
      ref="scrollWrapper"
      :style="useNativeScroll ? null : { top: top + 'px' }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
const delta = 15
const MOBILE_WIDTH = 1024

export default {
  name: 'scrollBar',
  data() {
    return {
      top: 0,
      useNativeScroll: false
    }
  },
  mounted() {
    this.updateScrollMode()
    window.addEventListener('resize', this.updateScrollMode)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollMode)
  },
  methods: {
    updateScrollMode() {
      const native = window.innerWidth <= MOBILE_WIDTH
      this.useNativeScroll = native
      if (native) {
        this.top = 0
      }
    },
    handleScroll(e) {
      // 手机端用原生 touch 滚动，禁止 preventDefault，否则会锁死滚动
      if (this.useNativeScroll) return
      e.preventDefault()
      const eventDelta = e.wheelDelta || -e.deltaY * 3
      const $container = this.$refs.scrollContainer
      const $containerHeight = $container.offsetHeight
      const $wrapper = this.$refs.scrollWrapper
      const $wrapperHeight = $wrapper.offsetHeight
      if (eventDelta > 0) {
        this.top = Math.min(0, this.top + eventDelta)
      } else if ($containerHeight - delta < $wrapperHeight) {
        if (this.top >= -($wrapperHeight - $containerHeight + delta)) {
          this.top = Math.max(this.top + eventDelta, $containerHeight - $wrapperHeight - delta)
        }
      } else {
        this.top = 0
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../styles/variables.scss';

.scroll-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: $menuBg;
  .scroll-wrapper {
    position: absolute;
    width: 100%!important;
  }
}

.scroll-container.is-native {
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  min-height: 0;

  .scroll-wrapper {
    position: static !important;
    top: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollBar/index.vue